module.exports = __webpack_public_path__ + "img/info_icon.e8809a1f.svg";